export * from './cloudTypes';
export * from './configProperties';

export const ValidationErrors = {
    email: 'Please input your email',
    password: 'Please input your password',
    confirmPassword: 'Please confirm your password',
    matchPassword: 'The two passwords do not match',
    resetCode: 'Please input your reset code',
    required: (fieldName) => `${fieldName} is required.`,
    requiredSelect: (fieldName) => `Please select a ${fieldName}`,
    LDAP: 'Please input your LDAP username',
    termsAndConditions: 'Please accept the terms and conditions',
};

export const NotificationErrors = {
    protectionStatus: 'Failed to fetch protection status',
    backupStatus: 'Failed to fetch backup status.',
    protectionAppliannces: 'Failed to load Protection Appliances',
    drPolicies: 'Failed to load DR Policies',
    backupPolicies: 'Failed to load Backups Policies',
    drEntitlements: 'Failed to load DR entitlements',
    activeMigrations: 'Failed to load Active Migrations',
    scheduledMigrations: 'Failed to load Scheduled Migrations',
    migrationStatus: 'Failed to load Migration Status',
    sources: 'Failed to load Sources',
    migrationAppliances: 'Failed to load Migration Appliances',
    backupAppliances: 'Failed to load Backup Appliances',
    migrationEntitlements: 'Failed to load Migration Entitlements',
};

export const vSphereVersions = [
    {
        version: 'GCVE',
        label: 'vSphere 7.0 U2 / GCVE',
        tools_package: 'vmwaretools-12.3.0.tar.gz',
        hardware_version: '19',
    },
    {
        version: 'AVS',
        label: 'vSphere 7.0 U3 / AVS',
        tools_package: 'vmwaretools-12.3.0.tar.gz',
        hardware_version: '19',
    },
    {
        version: 'ESXi_9_0',
        label: 'vSphere 9.0',
        tools_package: 'vmwaretools-13.0.1.tar.gz',
        hardware_version: '22',
    },
    {
        version: 'ESXi_8_0_u2',
        label: 'vSphere 8.0 U2',
        tools_package: 'vmwaretools-12.3.5.tar.gz',
        hardware_version: '21',
    },
    {
        version: 'ESXi_8_0',
        label: 'vSphere 8.0',
        tools_package: 'vmwaretools-12.3.0.tar.gz',
        hardware_version: '20',
    },
    {
        version: 'ESXi_7_0',
        label: 'vSphere 7.0',
        tools_package: 'vmwaretools-12.3.0.tar.gz',
        hardware_version: '17',
        default_value: true,
    },
    {
        version: 'ESXi_6_7_U2',
        label: 'vSphere 6.7 U2',
        tools_package: 'vmwaretools-10.3.5.tar.gz',
        hardware_version: '15',
    },
    {
        version: 'ESXi_6_7',
        label: 'vSphere 6.7 U1',
        tools_package: 'vmwaretools-10.3.2.tar.gz',
        hardware_version: '14',
    },
    {
        version: 'ESXi_6_5',
        label: 'vSphere 6.5',
        tools_package: 'vmwaretools-10.1.0.tar.gz',
        hardware_version: '13',
    },
    {
        version: 'ESXi_6_0',
        label: 'vSphere 6.0',
        tools_package: 'vmwaretools-9.10.0.tar.gz',
        hardware_version: '11',
    },
];

export const ApplianceStates = {
    PENDING: 'pending',
    RUNNING: 'running',
    UPGRADING: 'upgrading',
    SUCCESS: 'success',
    ERROR: 'error',
};
export const UserRoles = {
    ADMIN: 'ADMIN',
    ORG_ADMIN: 'ORG_ADMIN',
    USER: 'USER',
    VIEWER: 'VIEWER',
    SUPPORT: 'SUPPORT',
    GLOBAL_ADMIN: 'GLOBAL_ADMIN',
};

export const NIL_UUID = '00000000-0000-0000-0000-000000000000';

// View mode states for collapsing/expanding sections
export const ViewModeState = {
    OPEN: 'open',
    COLLAPSED: 'collapsed',
    HIDDEN: 'hidden',
};
